import currencyFormat from "scripts/utils/currencyFormat"
import sliders, { jobTeamSlider, jobValuesSlider } from "scripts/components/sliders"
import addGlobalEvent from "scripts/utils/addGlobalEvent"
import header from "scripts/components/header"
import response from "scripts/components/response"
import forms from "scripts/components/forms"
import modals from "scripts/components/modals"
import wishlist from "scripts/components/wishlist/wishlist"
import Select from "scripts/components/select"
import setAppLinksParams from "scripts/components/setAppLinksParams"
import { GAPageView } from "scripts/components/ga/page_view"
import renderModalVacanciesFilter from "scripts/components/react/ModalVacanciesFilter"
import renderModalVacanciesForm from "scripts/components/react/ModalVacanciesForm"
import renderModalVacanciesCv from "scripts/components/react/ModalVacanciesCv"
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

const startScripts = () => {
  GAPageView()

  header()
  response()
  forms()
  modals()
  setAppLinksParams()
  //   wishlist()
  initSupport();
  initLazyLoadingRecaptcha();
  addGlobalEvent(
    document,
    "click",
    ".js_activated_toggle",
    function activateToggleBlock() {
      if (!this) return
      this.closest(".js_activated_block").classList.toggle("active")
    },
  )

  // Open mobile filter
  addGlobalEvent(
    document,
    "click",
    ".js_mobile_vacancies_filter_opener",
    function activateToggleBlock() {
      renderModalVacanciesFilter()
    },
  )

  // Open vacancies form
  addGlobalEvent(
    document,
    "click",
    ".js_vacancy_form_opener",
    function activateToggleBlock() {
      renderModalVacanciesForm()
    },
  )

  // Open vacancies form cv
  addGlobalEvent(
    document,
    "click",
    ".js_vacancy_cv_opener",
    function activateToggleBlock() {
      renderModalVacanciesCv()
    },
  )

  window.customSelect = new Select()

  setTimeout(jobValuesSlider, 20)
  setTimeout(jobTeamSlider, 40)
}

document.addEventListener("DOMContentLoaded", startScripts)
